import { useEffect } from 'react';

import { atom, useAtom } from 'jotai';

export interface AcademyHistory {
  id: string;
  name: string;
  review: {
    totalScore: number;
    totalCount: number;
  };
  properties: string[];
  image: string;
}

// 최근 본 학원 목록을 저장할 atom
const viewedAcademiesAtom = atom<AcademyHistory[]>([]);

export function useAcademyHistory() {
  const [viewedAcademies, setViewedAcademies] = useAtom(viewedAcademiesAtom);
  const STORAGE_KEY = 'viewed_academies';
  const MAX_HISTORY = 10; // 최대 저장 개수

  // localStorage에서 저장된 학원 목록 불러오기
  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      setViewedAcademies(JSON.parse(stored));
    }
  }, []);

  // 학원 추가
  const addAcademyHistory = (academy: AcademyHistory) => {
    setViewedAcademies((prev) => {
      // 중복 제거
      const filtered = prev.filter((item) => item.id !== academy.id);
      // 최신 항목을 앞에 추가
      const updated = [academy, ...filtered].slice(0, MAX_HISTORY);

      // localStorage에 저장
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  };

  // 학원 삭제
  const removeAcademyHistory = (academyId: string) => {
    setViewedAcademies((prev) => {
      const updated = prev.filter((item) => item.id !== academyId);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  };

  // 전체 기록 삭제
  const clearAcademyHistory = () => {
    localStorage.removeItem(STORAGE_KEY);
    setViewedAcademies([]);
  };

  return {
    viewedAcademies,
    addAcademyHistory,
    removeAcademyHistory,
    clearAcademyHistory,
  };
}
